module.exports = __webpack_public_path__ + "static/media/5.fc88ce58.jpg";